const config = {
  apiUrl: process.env.REACT_APP_API_URL || "/reports-api",
  imgUrl: "https://mpa.noventa-consulting.com/",
};
export default config;
